export default {
  email: '',
  password: '',
  remember: false,
};
